import Chip from "@mui/material/Chip";
import { emphasize, Theme } from "@mui/material/styles";
import { styled } from "@mui/system";
import { dp } from "ds_legacy/materials/metrics";
import { FONT_SIZE_24 } from "ds_legacy/materials/typography";
import { XCircleIcon } from "lucide-react";
import { MultiValueProps } from "react-select";
import { SelectOption, SelectType } from "./types";

function getChipBackground(isFocused: boolean | undefined, theme: Theme) {
  if (!isFocused) {
    return undefined;
  }
  if (theme.palette.mode === "light") {
    return emphasize(theme.palette.grey[300], 0.08);
  }
  return emphasize(theme.palette.grey[600], 0.08);
}

export const StyledChip = styled(Chip, {
  shouldForwardProp: (prop) =>
    typeof prop === "string" && !["isFocused"].includes(prop),
})<Pick<SelectType, "value"> & { isFocused: boolean | undefined }>(
  ({ isFocused, theme }) => ({
    background: getChipBackground(isFocused, theme),
    margin: theme.spacing(1 / 2, 1 / 4),
  }),
);

export function MultiValue({
  children,
  data,
  isFocused,
  removeProps,
  selectProps: { withShortValue },
}: MultiValueProps<SelectOption>) {
  const displayValue = `${withShortValue ? data.value : data.label}`;
  return (
    <StyledChip
      deleteIcon={
        <div>
          <XCircleIcon
            fontSize={FONT_SIZE_24}
            style={{ height: dp(24), width: dp(24) }}
            {...(removeProps as any)}
          />
        </div>
      }
      isFocused={isFocused}
      label={displayValue || children}
      tabIndex={-1}
      onDelete={removeProps.onClick}
    />
  );
}
